import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';

export const TRENDING_CREATORS_TEST_NAME = 'Homepage_TrendingCreators_May2025';

export const isTrendingCreatorsVariant = (): boolean =>
    getAbTestV2(TRENDING_CREATORS_TEST_NAME)?.variant === 'variant';
